import { makeColumnsCompleted } from './columns-completed';
import { makeColumnsInProgress } from './columns-in-progress';
import { makeColumnsLost } from './columns-lost';
import { makeColumnsScheduled } from './columns-scheduled';

export const ColumnsActivities = {
  1: makeColumnsScheduled,
  2: makeColumnsInProgress,
  3: makeColumnsCompleted,
  7: makeColumnsLost,
};
